import { Children, cloneElement } from 'react';
import { useFormContext } from 'react-hook-form';

import type { FC, ReactElement } from 'react';

export interface FormProviderProps {
  children: ReactElement;
}

export const FormSubmit: FC<FormProviderProps> = ({ children }) => {
  const { formState } = useFormContext();

  return (
    <>
      {Children.map( children, (child, index) => cloneElement( child, { key: index, formState } ) )}
    </>
  );
};
